import { CLEAR_CUSTOMER_SLOT } from './types';

const clearCustomerSlot = () => dispatch => {
  dispatch({ type: CLEAR_CUSTOMER_SLOT });
};

export default clearCustomerSlot;
